/** Intended path kept across the purchase / guest-welcome gate and OAuth-style card round trips. */
const STORAGE_KEY = 'tmm_return_to';

let memory: string | null = null;

function isGatePath(path: string): boolean {
  return path === '/' || path.startsWith('/auth/') || path.startsWith('/ref/');
}

/** Remember a deep link the gate is about to redirect away from. */
export function rememberReturnTo(pathWithSearch: string): void {
  if (pathWithSearch.length === 0 || isGatePath(pathWithSearch.split('?')[0] ?? pathWithSearch)) {
    return;
  }
  memory = pathWithSearch;
  try {
    sessionStorage.setItem(STORAGE_KEY, pathWithSearch);
  } catch {
    // sessionStorage may be unavailable (private mode / quota) — memory still holds it.
  }
}

export function peekReturnTo(): string | null {
  if (memory !== null) return memory;
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/** Consume and clear the stored return path (first render of `app`, or after LET'S GO). */
export function consumeReturnTo(): string | null {
  const value = peekReturnTo();
  memory = null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  return value;
}

/** Test helper — wipe module + storage state. */
export function clearReturnToForTests(): void {
  memory = null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
